var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle121(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 484.8,
    height: 480,
    viewBox: "0 0 484.8 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u7xbmrq0ua",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0ff8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1cb691"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 121",
    cx: 2.4,
    cy: 90,
    rx: 92.4,
    ry: 90,
    transform: "rotate(-180 167.4 165)",
    style: {
      opacity: 0.5,
      fill: "url(#u7xbmrq0ua)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle121);
export default __webpack_public_path__ + "static/media/circle_121.38aa66a091192558dcd738b3235e5d03.svg";
export { ForwardRef as ReactComponent };